import { Box, Flex, Heading } from '@radix-ui/themes';

function AcademicWork() {
    return (
        <>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#E6BE16' }}>
                    ODIN'S BEARD
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} justify={{ xl: 'between' }} gap="4" wrap="wrap">
                    <Box style={{ aspectRatio: '1/1', maxWidth: 455, maxHeight: 455, overflow: 'hidden' }}>
                        <img
                            src={'/images/BeardYellow.png'}
                            alt="Odin's Beard"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Box style={{ aspectRatio: '666/500', maxWidth: 606, maxHeight: 455, overflow: 'hidden' }}>
                        <img
                            src={'/images/BeardLetterhead.png'}
                            alt="Letterhead Odin's Beard"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Box style={{ aspectRatio: '334/500', maxWidth: 304, maxHeight: 455, overflow: 'hidden' }}>
                        <img
                            src={'/images/BeardMockup.png'}
                            alt="Mockup Odin's Beard"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                </Flex>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="wrap" mt="4">
                    <Box style={{ aspectRatio: '522/400', maxWidth: 522, maxHeight: 400, overflow: 'hidden' }}>
                        <img
                            src={'/images/AllBeard.png'}
                            alt="Mockup Odin's Beard"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Box
                        pl={{ xl: '6' }}
                        maxWidth={{ xl: '60%' }}
                        style={{ alignSelf: 'center' }}
                    >
                        <Heading as="h4" size="8" weight="regular">
                            Odin's Beard is a fictional brand of beard oil. This collection showcases the brand logo, letterhead/business
                            card, and UX/UI designs. Each component such as the palette, typography, emphasis on vertically, and beard motif
                            was designed around the brand language generated from the primary logo.
                        </Heading>
                    </Box>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#E6BE16' }}>
                    BONKS
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} justify={{ xl: 'between' }} gap="4" wrap="wrap" mt="4">
                    <Box style={{ aspectRatio: '583/450', maxHeight: 450, maxWidth: 583, overflow: 'hidden' }}>
                        <img
                            src={'/images/BONKS_6pack.png'}
                            alt="BONKS 6 pack"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Box style={{ aspectRatio: '717/450', maxHeight: 450, maxWidth: 717, overflow: 'hidden' }}>
                        <img
                            src={'/images/BONKS_OrangeCreamSoda.png'}
                            alt="BONKS Orange Cream Soda"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                </Flex>
                <Box flexGrow="1" pt="6" style={{ alignSelf: 'center' }}>
                    <Heading as="h4" size="8" weight="regular">
                        BONKS Cream Soda is a fictional brand of orange cream soda. The series consists of the product design of the BONKS
                        orange cream soda aluminum can, as well as packaging design on the six can container. The can design, which
                        took precedence, was conceived under inspiration of the flowing nature of liquids and the imagery language of orange
                        cream. The further packaging design exhibited in the six pack container derives from the same inspiration as the
                        can, as well as extending the can's design in which it appears to naturally meld itself to the box walls.
                    </Heading>
                </Box>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#E6BE16' }}>
                    BEOWULF
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="wrap" mt="4">
                    <Box maxWidth={{ xl: '60%' }} style={{ alignSelf: 'center' }}>
                        <Heading as="h4" size="8" weight="regular">
                            This project consisted of taking an older piece of literature and reformatting it into a cohesive and visually
                            appealing product. Seeing as the Original Beowulf is a heroic poem, I used a stanza based system as seen in
                            theatrical playbooks, and complimented the aged story with appropriate typographical elements. Similar attention
                            was allotted to the original book sleeve design which was developed with the metallic stylization resembling
                            ancient bronze with the text detailed as extrusions from the surface.
                        </Heading>
                    </Box>
                    <Box style={{ aspectRatio: '511/500', maxHeight: 500, maxWidth: 511, overflow: 'hidden' }}>
                        <img
                            src={'/images/Beowulf.png'}
                            alt="Beowulf"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                </Flex>
            </Box>
        </>
    );
}

export default AcademicWork;
